module.exports = __webpack_public_path__ + "img/consultBtn.e4d29ad5.svg";